import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { MaskService } from 'src/app/shared/services/mask.service';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { IndicadoresPgService } from '../../services/indicadores-pg.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-detalhe-pg-indicadores-meta-edit',
  templateUrl: './detalhe-pg-indicadores-meta-edit.component.html',
  styleUrls: ['./detalhe-pg-indicadores-meta-edit.component.scss']
})
export class DetalhePgIndicadoresMetaEditComponent extends BaseFormComponent<IndicadoresProjeto> implements OnInit {

  pg_id: number;
  indicador: IndicadoresProjeto;
  type: string = '';

  constructor(
    private myService: IndicadoresPgService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pg_id = this.activatedRoute.snapshot.params['id'];
    this.type = this.activatedRoute.snapshot.data['type'];
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      goals: new FormArray([]),
    });

    this.entity?.goals?.forEach(value => {
      this.getFormArray().push(this.createFormGroup(value));
    });

    if (this.entity?.readonly) {
      this.form.disable();
    }
  }

  createFormGroup(value = null): FormGroup {
    return new FormGroup({
      id: new FormControl(value?.id),
      year: new FormControl(value?.year),
      goal: new FormControl(value?.goal),
    });
  }

  getFormArray(): FormArray {
    return this.form.get('goals') as FormArray;
  }

  voltar() {
    this.navigation.back(['projetos', this.type ?? 'agregador', 'indicadores', this.entity?.id]);
  }

  getDataCreate(): IndicadoresProjeto {
    let data: IndicadoresProjeto;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.updateMetaRealizado(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.msgSuccess('Meta Indicador alterado com sucesso!')
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  formatarMedidaFisica(index: number, field: string) {
    let goalValue = this.getFormArray().controls[index].get(field)?.value;
    let value = this.maskService.formatarMedidaFisica(goalValue, this.entity?.decimal_places);
    this.getFormArray().controls[index].get(field).setValue(value);
  }

}
